import axios from 'axios';
import { helperGetApiHeaders, helperGetApiCategoryUrlRoute } from 'helpers/ApiHelper';

const FETCH_DETAIL_CATEGORY = 'FETCH_DETAIL_CATEGORY';
const CLEAR_DETAIL_CATEGORY = 'CLEAR_DETAIL_CATEGORY';

function fetchCategoryDetail(id, accessToken, deviceId) {
  const pageType = 'category';
  const route = helperGetApiCategoryUrlRoute({ id, isPersonality: true });
  const request = axios.get(
    route,
    helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
  );
  return {
    type: FETCH_DETAIL_CATEGORY,
    payload: request,
  };
}

function clearCategoryDetail() {
  return {
    type: CLEAR_DETAIL_CATEGORY,
  };
}

export { FETCH_DETAIL_CATEGORY, CLEAR_DETAIL_CATEGORY, fetchCategoryDetail, clearCategoryDetail };
